import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { AiAssistantRequestDTO } from '@signature-it/ngx-generic/models';
import {catchError, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AiService {
  protected apiUrl =  `${this.restUrlsConf.appURL}/private/ai/assistant`;
  protected searchUrl =  `${this.restUrlsConf.appURL}/private/ai/search`;
  protected embedFileUrl =  `${this.restUrlsConf.appURL}/private/ai/embed-file`;
  public threadId = '';


  constructor(private http: HttpClient,
              protected restUrlsConf: RestUrlsConfig) {}


  sendMessage(data: AiAssistantRequestDTO): Observable<{ response: string }> {
    return this.http.post<{ response: string }>(this.apiUrl, JSON.stringify( data));
  }

  sendSearchMessage(data: AiAssistantRequestDTO): Observable<{ response: string }> {
    return this.http.post<{ response: string }>(this.searchUrl, JSON.stringify( data));
  }


  embedFile(type:string, id:string): Observable<{ response: string }> {
    let attributes = {};
    attributes['id'] = id;
    attributes['type'] = type;
    let data = JSON.stringify(attributes);
    return this.http.post<{ response: string }>(this.embedFileUrl, data).pipe(
        catchError((error) => throwError(() => new Error(error)))
    );
  }
}
